import { render, staticRenderFns } from "./AssetsMaterialsSuppliersCreate.vue?vue&type=template&id=6087398b&"
import script from "./AssetsMaterialsSuppliersCreate.vue?vue&type=script&lang=js&"
export * from "./AssetsMaterialsSuppliersCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports